import reduceKeyToValue from 'forms-utils-lib/utils/object/reduceKeysToValue';
export const DEFAULT_LANG = 'en';
export const RtlLangs = ['ar', 'fa', 'ha', 'he', 'ks', 'ckb', 'ps', 'ur', 'yi'];
export const LangToFormsLangMap = {
  en: 'en',
  es: 'esES',
  de: 'de',
  ja: 'jaJP',
  fr: 'fr',
  pt: 'ptBR',
  'pt-br': 'ptBR',
  'es-mx': 'esMX',
  cs: 'cs',
  da: 'da',
  el: 'el',
  fi: 'fi',
  hu: 'hu',
  it: 'it',
  ko: 'ko',
  nl: 'nl',
  noNO: 'no-no',
  'no-no': 'no-no',
  pl: 'pl',
  sv: 'svSE',
  'zh-cn': 'zhCN',
  'zh-hk': 'zhHK',
  'zh-tw': 'zhTW',
  ru: 'ru',
  id: 'id',
  ro: 'ro',
  hr: 'hr',
  th: 'th',
  vi: 'vi',
  bn: 'bn'
};

// for lang with multiple entries
// set the default value to be used
const FormsLangToLangDefaults = {
  'pt-br': 'pt-br',
  ptBR: 'pt-br',
  noNo: 'no-no',
  sv: 'sv',
  es: 'es',
  ja: 'ja'
};
export const FormsLangToLangMap = Object.assign({}, reduceKeyToValue(LangToFormsLangMap), FormsLangToLangDefaults);
export const FormsLangToLegalConsentLangMap = Object.assign({}, FormsLangToLangMap, {
  pt: 'pt-pt',
  ptBR: 'pt-br',
  'pt-br': 'pt-br',
  no: 'no-no'
});
export const FormsLangToAdConsentLangMap = Object.assign({}, FormsLangToLangMap, {
  'no-no': 'no'
});